import { Link } from '@tanstack/react-router';
import { HubCarouselScroller } from '@/components/hub/HubCarouselScroller';
import { HUB_CAROUSEL_TRACK, HUB_GUTTER_X, RESOURCE_PEEK_WIDTH } from '@/components/hub/hubCarousel';
import { ResourceTile } from '@/components/hub/ResourceTile';
import type { WebResource } from '@/content/resources';
import { track } from '@/lib/analytics';
import { typeScale } from '@/lib/typography';

export { RESOURCE_PEEK_WIDTH } from '@/components/hub/hubCarousel';

type ResourceCarouselProps = {
  title: string;
  section: string;
  items: WebResource[];
  onOpen: (resource: WebResource) => void;
  badge?: string;
};

export function ResourceCarousel({ title, section, items, onOpen, badge }: ResourceCarouselProps) {
  if (!items.length) return null;
  return (
    <section className="mt-8 min-w-0">
      <div className={`mb-3 flex items-center justify-between gap-3 ${HUB_GUTTER_X}`}>
        <h2 className={`truncate ${typeScale.sectionTitle}`}>{title}</h2>
        <Link
          to="/app/resources"
          search={{ section }}
          onClick={() => track('Learning Hub View All Press', { section: title })}
          className={`-mr-1 shrink-0 rounded-lg px-1 py-1 hover:underline focus:outline-none focus-visible:ring-4 focus-visible:ring-[#399918]/20 ${typeScale.viewAll}`}
          aria-label={`View all ${title}`}
        >
          View All
        </Link>
      </div>
      <HubCarouselScroller testId={`resource-carousel-${section}`}>
        <div className={`${HUB_CAROUSEL_TRACK} gap-2`}>
          {items.map((resource) => (
            <div key={resource.href} className={`${RESOURCE_PEEK_WIDTH} shrink-0 snap-start`}>
              <ResourceTile
                resource={resource}
                widthClass="w-full"
                badge={badge}
                onOpen={() => onOpen(resource)}
              />
            </div>
          ))}
        </div>
      </HubCarouselScroller>
    </section>
  );
}
